import { render, staticRenderFns } from "./MbSessionForm.vue?vue&type=template&id=7f5e290e&"
import script from "./MbSessionForm.vue?vue&type=script&lang=js&"
export * from "./MbSessionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports